import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { toastr } from 'react-redux-toastr';

const MAX_PDF_SIZE = 5 * 1024 * 1024;

const PdfFileInput = ({ input }) => {
  const fileRef = useRef(null);
  const { value } = input;

  const onFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.pdf')) {
      toastr.error('Error', 'Solo se permiten archivos PDF');
      return;
    }
    if (file.size > MAX_PDF_SIZE) {
      toastr.error('Error', 'El PDF no puede superar los 5 MB');
      return;
    }

    input.onChange(file);
  };

  return (
    <div className="d-flex align-items-center">
      <input
        ref={fileRef}
        type="file"
        accept="application/pdf,.pdf"
        style={{ display: 'none' }}
        onChange={onFileChange}
      />
      <Button type="button" size="sm" color="secondary" onClick={() => fileRef.current.click()}>
        <i className="fa fa-upload" /> {value ? 'Cambiar' : 'Subir'}
      </Button>

      {value instanceof File && (
        <small className="ml-2 text-truncate" title={value.name}>{value.name}</small>
      )}

      {typeof value === 'string' && value && (
        <a href={value} target="_blank" rel="noopener noreferrer" className="ml-2">
          <i className="fa fa-file-pdf-o" /> Ver
        </a>
      )}
    </div>
  );
};

PdfFileInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChange: PropTypes.func,
  }).isRequired,
};

export default PdfFileInput;